export function getIsSystemPromptForAnalytics(isUserGenerated?: boolean): boolean {
	return !(isUserGenerated ?? true);
}
